<template>
  <b-th
    v-if="item.type === 'th' && !item.hidden"
    :rowspan="item.rowspan">
      {{item.value}}
  </b-th>
  <b-td
    class="CellWithComment"
    v-else-if="!item.hidden"
    :style="{ backgroundColor : item.background }">
      {{item.value}}
  </b-td>
</template>

<script>
export default {
  props: ['item']
}
</script>
